module.exports = __webpack_public_path__ + "static/img/kh-20.f04e229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-20.png
// module id = VWOO
// module chunks = 5